import jsQR from "jsqr";
import React, { useState } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useVerifyBookingByQrMutation } from "../../Redux/apis/ApiSlice";
import { notification } from "antd";
import dayjs from "dayjs";

const DetailByNameInfo = () => {
  const [verifyBookingByQr] = useVerifyBookingByQrMutation();
  const location = useLocation();
  // Destructure booking data directly from location.state.booking
  const bookingData = location.state?.booking;
  console.log("booking Data", bookingData);
  const userId = location.state?.userId;
  const [buyerName1, setBuyerName] = useState("");

  const parseQRCodeData = (data) => {
    // Convert the query string into an object
    const params = new URLSearchParams(data);
    // Extract the buyerName value
    const name = params.get("buyerName");
    // Decode any encoded characters (like %20 for spaces)
    return decodeURIComponent(name || "");
  };
  const scanQRCodeFromDataURI = async (dataURI) => {
    return new Promise((resolve, reject) => {
      try {
        // Create an image element to load the data URI
        const img = new Image();
        img.onload = () => {
          // Create a canvas to draw the image
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);

          // Extract image data from the canvas
          const imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );
          const code = jsQR(imageData.data, imageData.width, imageData.height);

          if (code) {
            resolve(code.data); // Resolve the QR code data
          } else {
            reject("No QR code found in the provided image.");
          }
        };

        img.onerror = () => reject("Failed to load the image.");
        img.src = dataURI; // Set the data URI as the source
      } catch (error) {
        reject(
          error.message || "An error occurred while processing the QR code."
        );
      }
    });
  };
  scanQRCodeFromDataURI(bookingData.qrCode)
    .then((result) => {
      const extractedName = parseQRCodeData(result);
      setBuyerName(extractedName);
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  const handleScanComplete = async () => {
    try {
      const response = await verifyBookingByQr({
        eventId: Number(bookingData?.eventDetails?.eventId),
        userId: Number(userId),
        bookingId: Number(bookingData?.bookingId),
        ticketCode: Number(bookingData?.code),
      }).unwrap();
      notification.success({ message: "Verification successful!" });
      // Show the result modal or popup only on success
    } catch (err) {
      console.error("Verification failed:", err);
      notification.error({
        message: err?.data?.error || "You can't scan this QR!",
      });
    }
  };
  const bookingsArray = Array.isArray(bookingData)
    ? bookingData
    : [bookingData];

  if (!bookingData || bookingsArray.length === 0 || !bookingsArray[0]) {
    return <Typography>No booking data available.</Typography>;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="92.5vh"
      bgcolor="#f5f5f5"
    >
      {bookingsArray.map((booking, index) => {
        const {
          bookingId,
          totalPrice,
          date,
          time,
          status,
          qrCode,
          buyerDetails: { buyerName },
          eventDetails: {
            ticketTypes = [],
            eventId,
            eventName,
            location: eventLocation,
            date: eventDate,
            time: eventTime,
          },
        } = booking;

        function formatDate(dateString) {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, "0"); // Ensures 2-digit day
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
          const year = date.getFullYear();
          return `${month}/${day}/${year}`;
        }

        function formatTime(timeStr) {
          // Split the input time into hours, minutes, and seconds
          let [hours, minutes] = timeStr.split(":").map(Number);

          // Determine AM or PM
          const period = hours >= 12 ? "PM" : "AM";

          // Convert to 12-hour format
          hours = hours % 12 || 12; // Converts 0 to 12 for midnight

          // Return the formatted time
          return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
        }
        return (
          <Box
            key={index}
            sx={{
              // width: "500px",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: 3,
              bgcolor: "white",
              textAlign: "center",
              mb: 3,
            }}
          >
            <Typography
              variant="h6"
              align="left"
              sx={{ mb: 2 }}
              fontWeight={"bold"}
            >
              Ticket Info
            </Typography>
            <Grid item xs={12} mb={2} align="left">
              <Typography variant="body1">
                Event Date: {dayjs(eventDate).format("MM/DD/YYYY")}
              </Typography>
              <Typography variant="h5">
                {eventName.length > 12
                  ? `${eventName.slice(0, 18)}...`
                  : eventName}
              </Typography>
            </Grid>

            {/* Data */}
            <Grid container spacing={2}>
              {/* Buyer & Event Name */}
              <Grid item xs={6} align="left">
                <Typography variant="body2" fontWeight="bold">
                  Buyer
                </Typography>
                <Typography variant="body1">{buyerName1}</Typography>
              </Grid>
              <Grid item xs={6} align="right">
                <Typography variant="body2" fontWeight="bold">
                  Event Name
                </Typography>
                <Typography variant="body1">{eventName}</Typography>
              </Grid>

              {/* Ticket Details with Booked Quantities */}
              {ticketTypes.length > 0 && (
                <>
                  <Grid item xs={6} align="left">
                    <Typography variant="body2" fontWeight="bold" pl={2}>
                      Ticket Types
                    </Typography>
                  </Grid>
                  <Grid item xs={6} align="right">
                    <Typography variant="body2" fontWeight="bold">
                      Booked Tickets
                    </Typography>
                  </Grid>

                  {ticketTypes.map((ticket, idx) => (
                    <>
                      <Grid item xs={6} align="left">
                        <Typography variant="body1" pl={2}>
                          {ticket.type}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} align="right">
                        <Typography variant="body1">
                          {ticket.quantity || 1}
                        </Typography>
                      </Grid>
                    </>
                  ))}
                </>
              )}

              {/* Location & Time */}
              <Grid item xs={6} align="left">
                <Typography variant="body2" fontWeight="bold">
                  Location
                </Typography>
                <Typography variant="body1">{eventLocation}</Typography>
              </Grid>
              <Grid item xs={6} align="right">
                <Typography variant="body2" fontWeight="bold">
                  Time
                </Typography>
                <Typography variant="body1">
                  {dayjs(eventDate).format("hh:mm A")}
                </Typography>
              </Grid>

              {/* Total Price & Ticket Type */}
              <Grid item xs={6} align="left">
                <Typography variant="body2" fontWeight="bold">
                  Total Price
                </Typography>
                <Typography variant="body1">${totalPrice}</Typography>
              </Grid>
              <Grid item xs={6} align="right">
                <Typography variant="body2" fontWeight="bold">
                  Ticket Type
                </Typography>
                <Typography variant="body1">
                  {bookingData?.ticketDetails?.ticketCategory}
                </Typography>
              </Grid>
            </Grid>

            <Box
              sx={{
                marginTop: "20px",
                marginBottom: "20px",
                width: "100%",
                height: "200px",
                backgroundImage:
                  "url(https://t4.ftcdn.net/jpg/02/16/94/65/360_F_216946587_rmug8FCNgpDCPQlstiCJ0CAXJ2sqPRU7.jpg)",
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderRadius: "10px",
              }}
            />
            {bookingData?.isOrganizer && (
              <Box sx={{ marginTop: "10px" }}>
                <Button
                  onClick={handleScanComplete}
                  sx={{ border: "1px solid" }}
                >
                  Authenticate
                </Button>
                <Typography
                  variant="caption"
                  display="block"
                  style={{ marginTop: "5px" }}
                >
                  Once authenticated, this ticket cannot be scanned again.
                </Typography>
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default DetailByNameInfo;
